import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=e40a5b4e&scoped=true&"
import script from "./balance.js?vue&type=script&lang=js&"
export * from "./balance.js?vue&type=script&lang=js&"
import style0 from "./balance.css?vue&type=style&index=0&id=e40a5b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40a5b4e",
  null
  
)

export default component.exports